// extracted by mini-css-extract-plugin
export default {"selectedProjectList":"gLLl8OhO6WXpq5M80f7p","empty":"xoDF7OZkmQ93aU_xcnwL","projects":"KlUC2R7MDTNt9eTuu1kh"};